import styled, {css} from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

interface GameSearchDefaultBoxProps {
    open: boolean;
}

const GameSearchMobileDefaultBox = styled.div<GameSearchDefaultBoxProps>`
     ${({open}) => open && css`
       flex: 1;
    `}
`;

const GameSearchPCDefaultBox = styled.div`
    position: relative;
    display: flex;
`;


export const GameSearchBox: any = styledByDevice(GameSearchPCDefaultBox, GameSearchMobileDefaultBox);